import * as ReactQuery from 'react-query';
import { Routing } from 'global/routing';
import {
  removeRefreshToken,
  setAccessToken,
  setRefreshToken,
  removeAuthProvider,
} from 'utils/auth';
import { Services } from 'services';
import { refreshIdmeAccessTokenAPI } from './api';

const IDME_REFRESH_TOKEN_KEY = '@auth/idme-refresh-access-token';

export function useIdmeRefreshAccessToken() {
  const { isLoading, isError, isSuccess } = ReactQuery.useQuery(
    IDME_REFRESH_TOKEN_KEY,
    refreshIdmeAccessTokenAPI,
    {
      onSuccess: (data) => {
        setAccessToken(data.id_token);
        setRefreshToken(data.refresh_token);
      },
      onError: () => {
        if (navigator.onLine) {
          removeRefreshToken();
          removeAuthProvider();
          window.location.href = Routing.LOGIN.getPath();
        }
      },
      refetchInterval: 180000, // 3 minutes
      refetchIntervalInBackground: true,
      refetchOnReconnect: true,
      staleTime: 920000, // 4 minutes
    }
  );

  const siteEmployeeService = Services.SiteEmployees.useGetCurrentSiteEmployee({
    enabled: isSuccess,
  });

  return {
    isLoading: isLoading || siteEmployeeService.isLoading,
    isError,
  };
}
